enum UserRole {
  PUBLIC = '',
  FREE = 'free',
  TRIAL = 'trial',
  PREMIUM = 'premium',
  LIFETIME = 'lifetime',
  ENTERPRISE = 'enterprise'
}
export default UserRole
